<template>
  <div :class="classes" />
</template>

<script lang="ts">
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    name: 'Resizer',
    props: {
      split: {
        type: String,
        required: true,
      },
      className: {
        type: String,
        default: '',
      },
    },
    setup(props) {
      const classes = computed(() => {
        return ['splitter-pane-resizer', props.split, props.className].join(' ');
      });

      return {
        classes,
      };
    },
  });
</script>

<style scoped></style>
